const _import = require('./_import')
const layout = _import('Layout/Layout');
export const Routers = [{
        path: '/',
        component: layout,
        redirect: "/Home",
        children: [{
            path: '/Home',
            component: _import('Layout/Home'),
            name: 'Home',
            single: true,
            meta: {
                title: "首页",
                icon: "home"
            }
        }]
    },
    {
        path: '/Login',
        hidden: true,
        component: _import('Login/Index'),
        name: 'Login',
        meta: {
            title: "登录"
        }
    },
    {
        path: '/info',
        redirect: "/pubinfolist",
        component: layout,
        children: [{
            path: '/pubinfolist',
            name: 'Pubinfolist',
            component: _import("Info/Pubinfolist/Index"),
            meta: {
                title: "信息公告",
                icon: "info"
            },
            single: true,
        },{
            path: 'infoView',
            name: 'InfoView',
            component: _import("Info/Pubinfolist/InfoView"),
            meta: {
                title: "信息详情"
            },
            query: {
                id: ""
            },
            hidden: true
        },]
    },
    {
        path: '/saledata',
        redirect: "/checkAccountMain",
        component: layout,
        children: [{
            path: '/checkAccountMain',
            name: 'CheckAccountMain',
            component: _import("SaleData/CheckAccountMain/Index"),
            meta: {
                title: "对账数据",
                icon: "salesData"
            },
            single: true,
        },{
            path: 'JSDDY_GYL',
            name: 'JSDDY_GYL',
            component: _import("FineReport/Index"),
            meta: {
                title: "结算单明细"
            },
            query: {
                id: ""
            },
            hidden: true
        },{
            path: 'monthsAmoDataDetail',
            name: 'MonthsAmoDataDetail',
            component: _import("SaleData/CheckAccountMain/Detail"),
            meta: {
                title: "月金额汇总明细"
            },
            query: {
                code: "",
                ym: "",
                channelId: ""
            },
            hidden: true
        },]
    },
    {
        path: '/matro',
        component: layout,
        redirect: "/matroHome",
        children: [{
            path: '/matroHome',
            component: _import('Layout/Home'),
            name: 'matro',
            single: true,
            meta: {
                title: "美罗商城官网",
                icon: "pchome"
            }
        }]
    },
]